import React from 'react';

import { TypographyTable } from '../index';

const bodyValues = [
  {
    cleanName: 'body-large',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: 0,
    fontWeight: 400,
  },
  {
    cleanName: 'body',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: 0,
    fontWeight: 400,
  },
  {
    cleanName: 'body-small',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: 0,
    fontWeight: 400,
  },
];

/**
 * __Typography body table__
 */
export const TypographyBodyTable = () => {
  return (
    <TypographyTable
      values={bodyValues}
      previewText="Body text over two or three lines"
      testId="typography-body-table"
    />
  );
};
